export default __webpack_public_path__ + "static/media/service_contract.b98738ac.pdf";